import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
  },
});

// Optional: export RootState and AppDispatch types for TS consumers (JS project keeps them for clarity)
export const getStore = () => store;

export default store;
